import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.Date @labelName='Date du don' @propertyName='transplantDate' />
  </div>

  <div class='field'>
    <@form.AlignedFieldsRadioGroup
      @title='Créatinine du donneur'
      @propertyName='donorCreatinine'
      as |Group|
    >
      <Group.FieldRadio @label='Ne sait pas' @value='unknown' />
      <Group.FieldRadio @label='> 190 µmol/L' @value='gt_190' />
      <Group.FieldRadio @label='<= 190 µmol/L' @value='lte_190' />
    </@form.AlignedFieldsRadioGroup>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
